import { render, staticRenderFns } from "./AddUserBillingSettings.vue?vue&type=template&id=18a3e0e1"
import script from "./AddUserBillingSettings.vue?vue&type=script&lang=js"
export * from "./AddUserBillingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports